import { importDataRecords } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useImportDataRecords = () => {
    const entityUpdater = useEntityQueryUpdate();

    const mutation = useMutation({
        mutationKey: 'import_data_file',
        mutationFn: (formData) => importDataRecords(formData),
        onSuccess: (data) => {
            entityUpdater([['data_files'], ['data_files', data.id]], data);
            notifications.show({
                title: 'Success',
                message: 'Successfully imported records',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useImportDataRecords;
